// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"498":"4dd711c9","513":"2447fad7","703":"a8bdd18c","787":"ed7e857d"}[chunkId] + ".chunk.js";
};